"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function round(value) {
    return Math.round(value * 100) / 100;
}
exports.round = round;
function drawSquare(ctx, x, y, size, { color = 'black', width = null, } = {}) {
    ctx.save();
    ctx.strokeStyle = color;
    if (width)
        ctx.lineWidth = width;
    ctx.strokeRect(x, y, size, size);
    ctx.restore();
}
exports.drawSquare = drawSquare;
function fillSquare(ctx, x, y, size, { color = 'black' } = {}) {
    // ctx.save();
    ctx.fillStyle = color;
    ctx.fillRect(x, y, size, size);
    // ctx.restore();
}
exports.fillSquare = fillSquare;



//////////////////
// WEBPACK FOOTER
// ./src/utils.ts
// module id = 2
// module chunks = 0